import classNames from 'classnames';
import Image from 'next/image';
import Link from 'next/link';
import { Dispatch, SetStateAction } from 'react';
import { ResponseNativeCard } from '@/src/interfaces/data-contracts';
import { Button } from '../../ui/button/button';

export const ProgrammableNC2 = ({
  item,
  setShowModal,
}: {
  item: ResponseNativeCard;
  setShowModal: Dispatch<SetStateAction<boolean>>;
}) => {
  const campaigns = item.nativeCardOfferCampaigns ?? [];
  const description = campaigns.map((c) => c.description).join(' ');
  return (
    <>
      <div
        data-id={item.id}
        data-ncid="nc-2"
        className="flex w-full flex-col items-center justify-between gap-4 rounded-lg p-4 md:hidden"
      >
        <div className="flex w-full flex-col items-center justify-between gap-4 rounded-lg">
          <div className="mt-8 flex w-full items-center justify-between">
            <div className="relative flex h-[48px] w-[104px] items-center justify-center rounded-md border border-gray-300 p-3 md:h-[66px] md:w-[122px]">
              {item.nativeCardPictures?.desktopImagePath && (
                <Image
                  src={item.nativeCardPictures?.desktopImagePath}
                  alt={item.nativeCardPictures?.altTitle ?? 'banka logo'}
                  className="hidden h-8 md:block"
                  fill
                  data-testid="image-desktop"
                />
              )}
              {item.nativeCardPictures?.tabletImagePath && (
                <Image
                  src={item.nativeCardPictures?.tabletImagePath}
                  alt={item.nativeCardPictures?.altTitle ?? 'banka logo'}
                  className="h-8 md:hidden"
                  fill
                  data-testid="image-tablet"
                />
              )}
              {item.nativeCardPictures?.mobileImagePath && (
                <Image
                  src={item.nativeCardPictures?.mobileImagePath}
                  alt={item.nativeCardPictures?.altTitle ?? 'banka logo'}
                  className="h-8 md:hidden"
                  fill
                  data-testid="image-mobile"
                />
              )}
            </div>
            <h2 className="text-xs font-semibold text-gray-800 md:whitespace-nowrap" data-testid="offer-product-name">
              {item.offerProductName}
            </h2>
          </div>

          <div className="flex w-full items-center justify-between gap-[80px]">
            <div
              className="text-left text-xs"
              data-testid="campaign-description"
              dangerouslySetInnerHTML={{ __html: description ?? '' }}
            />
          </div>
        </div>
        <div className="flex w-full justify-end gap-2">
          {item.isConditionActive && (
            <button
              onClick={() => setShowModal(true)}
              className="flex h-[48px] w-[106px] items-center justify-center bg-transparent px-8 py-4 text-center text-sm font-bold text-purple500 underline hover:underline"
            >
              Koşullar
            </button>
          )}
          {item.isConditionActive || item.isOfferPopUp ? (
            <Button
              onClick={() => setShowModal(true)}
              text={item.offerCTAText ?? ''}
              data-testid="cta-button"
              className="h-[48px] w-[194px] rounded-lg px-4 py-2 text-sm font-semibold text-white shadow-md transition"
            />
          ) : (
            <Link
              data-testid="cta-button"
              href={item.link ?? '#'}
              className="flex h-[48px] w-[194px] items-center justify-center rounded-lg bg-purple500 px-4 py-2 text-sm font-semibold text-white shadow-md transition"
            >
              {item.offerCTAText ?? ''}
            </Link>
          )}
        </div>
      </div>

      <div
        data-id={item.id}
        data-ncid="nc-2"
        className="hidden h-[156px] w-[1120px] items-center justify-between rounded-lg px-6 md:flex"
      >
        <div className="flex h-[156px] w-[1120px] items-center justify-between rounded-lg md:gap-8">
          <div className="flex items-center gap-4">
            <div className="relative flex h-[48px] w-[104px] items-center justify-center rounded-md border border-gray-300 p-3 md:h-[66px] md:w-[122px]">
              {item.nativeCardPictures?.desktopImagePath && (
                <Image
                  src={item.nativeCardPictures?.desktopImagePath}
                  alt={item.nativeCardPictures?.altTitle ?? 'banka logo'}
                  className="hidden h-8 md:block"
                  fill
                  data-testid="image-desktop"
                />
              )}
              {item.nativeCardPictures?.tabletImagePath && (
                <Image
                  src={item.nativeCardPictures?.tabletImagePath}
                  alt={item.nativeCardPictures?.altTitle ?? 'banka logo'}
                  className="h-8 md:hidden"
                  fill
                  data-testid="image-tablet"
                />
              )}
              {item.nativeCardPictures?.mobileImagePath && (
                <Image
                  src={item.nativeCardPictures?.mobileImagePath}
                  alt={item.nativeCardPictures?.altTitle ?? 'banka logo'}
                  className="h-8 md:hidden"
                  fill
                  data-testid="image-mobile"
                />
              )}
            </div>
          </div>

          <div className="mr-[168px] flex w-[578px] shrink-0 items-center justify-between gap-[80px]">
            <h2 className="min-w-24 font-semibold text-gray-800" data-testid="offer-product-name">
              {item.offerProductName}
            </h2>

            <div className="flex w-full items-center gap-[20px]">
              <div data-testid="campaign-description" dangerouslySetInnerHTML={{ __html: description ?? '' }} />
            </div>
          </div>
        </div>
        <div className="flex w-full flex-col items-end gap-2">
          {item.isConditionActive || item.isOfferPopUp ? (
            <Button
              onClick={() => setShowModal(true)}
              text={item.offerCTAText ?? ''}
              data-testid="cta-button"
              className="h-[48px] w-[182px] rounded-lg px-4 py-2 text-sm font-semibold text-white shadow-md transition"
            />
          ) : (
            <Link
              data-testid="cta-button"
              href={item.link ?? '#'}
              className="flex h-[48px] w-[182px] items-center justify-center rounded-lg bg-purple500 px-4 py-2 text-sm font-semibold text-white shadow-md transition"
            >
              {item.offerCTAText ?? ''}
            </Link>
          )}
          {item.isConditionActive && (
            <button
              onClick={() => setShowModal(true)}
              className="flex h-[48px] w-full items-center justify-center bg-transparent px-8 py-4 text-center text-sm font-bold text-purple500 underline hover:underline"
            >
              Koşullar
            </button>
          )}
        </div>
      </div>
      {item.offerSpecialDescription && (
        <div
          className={classNames(
            'absolute hidden w-full items-center rounded-bl-xl rounded-br-xl px-6 pb-2 text-xs font-semibold text-black800 md:flex',
            {
              'bottom-0': !item.offerShortDescription,
              'bottom-8': item.offerShortDescription,
            }
          )}
          data-testid="offer-special-description"
        >
          {item.offerSpecialDescription}
        </div>
      )}
      {item.offerShortDescription && (
        <div
          className="flex w-full items-center rounded-bl-xl rounded-br-xl bg-gray50 px-6 py-2 text-xs text-black700"
          data-testid="offer-special-description"
        >
          {item.offerShortDescription}
        </div>
      )}
    </>
  );
};
